exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-games-wrapper {\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  position: relative;\n  background: green;\n}\n.app-games-wrapper .app-games-iframe {\n  width: 100%;\n  height: 4.25rem;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  border: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/test/iframe2/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/test/iframe2/index.less
// module chunks = 0